export const DEFAULT_PRIMARY_COLOR = '#00c0b3';
export const DEFAULT_SECONDARY_COLOR = '#cfe8fc';
export const OHLA_DEFAULT_PRIMARY_COLOR = '#e31314';
export const OHLA_DEFAULT_SECONDARY_COLOR = '#cfe8fc';
export const DEFAULT_DASHBOARD_LOGO_URL = `/logo_touchlatam_white.png`;
export const DEFAULT_DASHBOARD_LOGO_HEIGHT = 40;
export const DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_BG = '#E6F4FF';
export const DEFAULT_DASHBOARD_MENU_ITEM_ACTIVE_BG = '#CCE9FF';
export const DEFAULT_DASHBOARD_MENU_ITEM_SELECTED_COLOR = '#1677FF';
export const USER_TYPES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  REGULAR_ACCOUNT: 'REGULAR_ACCOUNT',
};
export const LOGO_TOUCH_LATAM = '/logo_touchlatam.png';
export const LOGO_OHLA = '/logo_ohla.png';
export const DEFAULT_REDIRECT_AUTH_ROUTE = '/home';
export const DEFAULT_FAVICON_32_32_PNG = '/favicon-32x32.png';
export const SOCKET_NAMESPACE =
  process.env.REACT_APP_SOCKET_NAMESPACE || 'touch-portal';
export const SOCKET_SERVER_URL =
  process.env.REACT_APP_SOCKET_SERVER_URL || 'http://ws-example.com';

// Websockets channels
export const WS_COMPANY_CHANNEL = `company-notifications:[COMPANY_ID]`;
export const WS_USER_CHANNEL = `user-notifications:[USER_ID]`;

// Websockets events
export const UPDATE_DATA_INGESTOR_EVENT = `data-ingestor:update`;
